import React from 'react';

import { CalendlyButton } from 'components/SmartAssistantComponents/CalendlyButton';
import { MessageBubble, MessageBubbleProps } from 'components/SmartAssistantComponents/MessageBubble';
import { useCalendlyCTAVisibility } from 'hooks/use-calendly-cta-visibility';
import { CalendlyToolConfig } from 'shared/interfaces/tools/Calendly';
import { ToolConfig, ToolKind, ToolTrigger } from 'shared/interfaces/tools/Tool';

interface CalendlyButtonProps extends MessageBubbleProps {
  smartAssistantId?: string;
  toolConfigs?: ToolConfig[];
  forIntent?: boolean;
  conversationLength?: number;
}

export function CalendlyBubble({
  smartAssistantId,
  toolConfigs,
  forIntent = false,
  conversationLength = 0,
  ...messageBubbleProps
}: CalendlyButtonProps) {
  const [, setShowCalendlyCTA] = useCalendlyCTAVisibility(smartAssistantId);

  const calendlyToolConfig = (
    forIntent
      ? toolConfigs?.find(
          (toolConfig) => toolConfig.kind === ToolKind.CALENDLY && toolConfig.trigger === ToolTrigger.INTENT
        )
      : toolConfigs?.find(
          (toolConfig) =>
            toolConfig.kind === ToolKind.CALENDLY &&
            (toolConfig.trigger === ToolTrigger.WELCOME ||
              (conversationLength > 1 && toolConfig.trigger === ToolTrigger.FIRST_SMART_ASSISTANT_MESSAGE))
        )
  ) as CalendlyToolConfig | undefined;

  if (!calendlyToolConfig) return null;

  return (
    <MessageBubble onClose={!forIntent ? () => setShowCalendlyCTA(false) : undefined} {...messageBubbleProps}>
      <CalendlyButton
        smartAssistantVisualConfig={messageBubbleProps.smartAssistantVisualConfig}
        toolConfigs={toolConfigs}
        forcedCalendlyToolConfig={calendlyToolConfig}
      />
    </MessageBubble>
  );
}
